// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_TMYFF","box":"index_box_8LIaS","footer":"index_footer_3nQUD"};